/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const FileSearchV2Icon: React.FC<AllieIconProps> = ({ className, ...props }) => (
  <svg
    {...props}
    className={`stroke-icon ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
  >
    <path
      d="M23.3333 18.8333H13.3333M16.6667 25.4999H13.3333M26.6667 12.1666H13.3333M33.3333 17.9999V11.8333C33.3333 9.03299 33.3333 7.63286 32.7884 6.5633C32.309 5.62249 31.5441 4.85759 30.6033 4.37822C29.5337 3.83325 28.1336 3.83325 25.3333 3.83325H14.6667C11.8664 3.83325 10.4663 3.83325 9.39671 4.37822C8.4559 4.85759 7.691 5.62249 7.21163 6.5633C6.66667 7.63286 6.66667 9.03299 6.66667 11.8333V29.1666C6.66667 31.9668 6.66667 33.367 7.21163 34.4365C7.691 35.3774 8.4559 36.1423 9.39671 36.6216C10.4663 37.1666 11.8664 37.1666 14.6667 37.1666H19.1667M36.6667 37.1666L34.1667 34.6666M35.8333 30.4999C35.8333 33.7216 33.2217 36.3333 30 36.3333C26.7783 36.3333 24.1667 33.7216 24.1667 30.4999C24.1667 27.2783 26.7783 24.6666 30 24.6666C33.2217 24.6666 35.8333 27.2783 35.8333 30.4999Z"
      stroke="#344054"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
